import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
} from '@redteclab/api/clients/bully'

import { SELLER_ID_SAE } from './SELLER_ID_SAE'
import { userSubOrderAccessorIsNow } from './userSubOrderAccessor'

export const userSubOrderAccessorIsMarketplaceOrder = (
  subOrder: UserOrderResponseWithFlagsSubOrdersInner | UserSubOrderV2,
): boolean => {
  return (
    subOrder.sellerId !== SELLER_ID_SAE && !userSubOrderAccessorIsNow(subOrder)
  )
}
